import PaymentTermsContainer from "./PaymentTermsContainer";
export default PaymentTermsContainer;
